import { render, staticRenderFns } from "./legal-entity-selector.vue?vue&type=template&id=288e2008"
import script from "./legal-entity-selector.ts?vue&type=script&lang=js&external"
export * from "./legal-entity-selector.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports